import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 25 24", ...l }, /* @__PURE__ */ e.createElement("path", { fill: "#1f2830", fillRule: "evenodd", d: "m19.718 15.943 4.642 4.643c.78.78.78 2.045 0 2.826a2.024 2.024 0 0 1-2.826 0l-4.642-4.641a10.25 10.25 0 1 1 2.826-2.828m-1.268-5.687a7.246 7.246 0 0 0-7.246-7.246 7.254 7.254 0 0 0-7.245 7.246 7.246 7.246 0 1 0 14.49 0", clipRule: "evenodd" }));
export {
  t as default
};
